<lib-default-progress-bar
  [desginOptions]="desginOptions"
  [translations]="translations"
  [isDeliveryOrder]="orderAppService.isDeliveryOrder()"
  [activeFunc]="isActive.bind(this)"
></lib-default-progress-bar>